import HomeIcon from "@mui/icons-material/Home";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import GroupIcon from "@mui/icons-material/Group";
import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';
import CategoryIcon from '@mui/icons-material/Category'
import DashboardIcon from '@mui/icons-material/Dashboard'
import GradingIcon from '@mui/icons-material/Grading';

// export const SidebarData = [
//   {
//     title: "Home",
//     path: "/Home",
//     Icon: HomeIcon,
//     subNav: [
//       {
//         title: "Dashboard",
//         path: "/Home/Dashboard",
//         Icon: DashboardIcon,
//       },
//       {
//         title: "Pramotion",
//         path: "/Home/Pramotion",
//         Icon: InventoryRoundedIcon,
//       },
//       {
//         title: "Banner",
//         path: "/Home/Banner",
//         Icon: ViewCarouselIcon,
//       },
//       {
//         title: "Ads Poster",
//         path: "/Home/AdsPoster",
//         Icon: ViewCarouselIcon,
//       },
//       {
//         title: 'Category',
//         path: '/Home/Category',
//         Icon: CategoryIcon
//       },
//       {
//         title: "Product",
//         path: "/Home/Product",
//         Icon: InventoryRoundedIcon,
//       }
//     ],
//   },
//   {
//     title: "CRM",
//     path: "/CRM",
//     Icon: GroupIcon,
//     subNav: [
//       {
//         title: "Users",
//         path: "/CRM/User",
//         Icon: GroupIcon,
//       },
//     ],
//   },
//   {
//     title: "My Order",
//     path: "/MyOrder",
//     Icon: GradingIcon,
//     subNav: [
//       {
//         title: "Orders",
//         path: "/MyOrder/Orders",
//         Icon: GradingIcon,
//       },
//     ],
//   },
// ];


export const SidebarData = [
  {
    title: "Dashboard",
    path: "/Dashboard",
    Icon: DashboardIcon,
  },
  {
    title: "Pramotion",
    path: "/Pramotion",
    Icon: InventoryRoundedIcon,
  },
  {
    title: "Banner",
    path: "/Banner",
    Icon: ViewCarouselIcon,
  },
  {
    title: "Ads Poster",
    path: "/AdsPoster",
    Icon: ViewCarouselIcon,
  },
  {
    title: 'Category',
    path: '/Category',
    Icon: CategoryIcon
  },
  {
    title: "Product",
    path: "/Product",
    Icon: InventoryRoundedIcon,
  },
  {
    title: "Users",
    path: "/User",
    Icon: GroupIcon,
  },
  {
    title: "Orders",
    path: "/Orders",
    Icon: GradingIcon,
  },
];
